<template>
  <div class="sectionOuterBox">
    <div class="sectionInnerBox text-left py-12">
      <v-container class="container">
        <v-row>
          <v-col md="6" sm="12" class="hidden-xs hidden-sm hidden-xxs">
            <div class="sectionImage2">
              <img class="boxShadow borderRadius8" src="https://cdn.planbook.com/images/schoolCurriculum.png"
                :alt="$t('schools.curriculum.imageAlt')">
            </div>
          </v-col>
          <v-col md="6" sm="12">
            <div class="sectionListHeader md cBlue">{{ $t('schools.curriculum.title') }}</div>
            <div class="sectionImage2 hidden-md hidden-lg hidden-xlg my-10">
              <img class="boxShadow borderRadius8" src="https://cdn.planbook.com/images/schoolCurriculum.png"
                :alt="$t('schools.curriculum.imageAlt')">
            </div>
            <div>
              <ul class="sectionList md pl-0 my-4">
                <li><i class="cBlue fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('schools.curriculum.features.store') }}</span></li>
                <li><i class="cBlue fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('schools.curriculum.features.consistency') }}</span></li>
                <li><i class="cBlue fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('schools.curriculum.features.control') }}</span></li>
                <li><i class="cBlue fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('schools.curriculum.features.customize') }}</span></li>
                <li><i class="cBlue fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('schools.curriculum.features.permissions') }}</span></li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Curriculum extends Vue {
}
</script>

<style lang="scss" scoped></style>
